import { assert_number_gte_0, assert_string_object_id } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class RequestWorkspaceUserCreditsLimitUpdate extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_WORKSPACE_USER_CREDITS_LIMIT_UPDATE;

  workspace_id!: string;
  target_user_id!: string;
  value!: number;

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    assert_string_object_id(this.workspace_id);
    assert_string_object_id(this.target_user_id);
    assert_number_gte_0(this.value);
  }
}
